// Published-timeline visual themes. The timeline is the protagonist.
export const THEMES = {
  aurora: {
    name: "Aurora",
    dark: true,
    bg: "#0E0A1F",
    bgGradient: "radial-gradient(1200px 600px at 15% -10%, #2A1A5E 0%, transparent 55%), radial-gradient(900px 500px at 100% 10%, #3A1F6E 0%, transparent 50%), #0E0A1F",
    surface: "#171128",
    surfaceBorder: "#2C2148",
    text: "#F5F3FF",
    muted: "#B4A9D6",
    accent: "#9B7BE0",
    accent2: "#C4A7F5",
    line: "linear-gradient(180deg, #6D4AB8, #9B7BE0, #C4A7F5)",
    dot: "#9B7BE0",
    heading: "'Outfit', sans-serif",
  },
  midnight: {
    name: "Midnight",
    dark: true,
    bg: "#060814",
    bgGradient: "radial-gradient(1000px 600px at 80% -10%, #1E2A5E 0%, transparent 55%), #060814",
    surface: "#0E1428",
    surfaceBorder: "#1C2545",
    text: "#EAF0FF",
    muted: "#93A2C7",
    accent: "#6E8BFF",
    accent2: "#8EA6FF",
    line: "linear-gradient(180deg, #3B4E9E, #6E8BFF, #A7BCFF)",
    dot: "#6E8BFF",
    heading: "'Outfit', sans-serif",
  },
  paper: {
    name: "Paper",
    dark: false,
    bg: "#FBFAF7",
    bgGradient: "#FBFAF7",
    surface: "#FFFFFF",
    surfaceBorder: "#E7E3DA",
    text: "#1C1A17",
    muted: "#6B655C",
    accent: "#3A1F6E",
    accent2: "#6D4AB8",
    line: "linear-gradient(180deg, #3A1F6E, #6D4AB8)",
    dot: "#3A1F6E",
    heading: "'Cormorant Garamond', serif",
  },
  sunrise: {
    name: "Sunrise",
    dark: false,
    bg: "#FFFBF5",
    bgGradient: "radial-gradient(900px 500px at 10% -10%, #FFE9CC 0%, transparent 55%), #FFFBF5",
    surface: "#FFFFFF",
    surfaceBorder: "#F1E4D2",
    text: "#2A1E10",
    muted: "#8A7358",
    accent: "#D97706",
    accent2: "#F59E0B",
    line: "linear-gradient(180deg, #D97706, #F59E0B, #FCD34D)",
    dot: "#D97706",
    heading: "'Outfit', sans-serif",
  },
};

export const LAYOUTS = [
  { id: "vertical", name: "Vertical Story", desc: "Events flow down the page. Best for storytelling and articles." },
  { id: "horizontal", name: "Horizontal", desc: "Classic left-to-right chronology with scroll and zoom." },
  { id: "cards", name: "Cards", desc: "Large editorial cards arranged chronologically." },
  { id: "fullscreen", name: "Fullscreen Story", desc: "Each event fills the viewport. Interactive documentary." },
  { id: "zigzag", name: "Zigzag", desc: "Events alternate around a central chronological line." },
  { id: "map", name: "Map", desc: "Events appear geographically; selecting one moves the map." },
  { id: "branches", name: "Branches", desc: "Events fork into parallel paths for alternate histories & scenarios." },
];

export const CATEGORIES = [
  "Personal Timeline", "Historical Timeline", "Company Timeline", "Product Roadmap",
  "Project Timeline", "Biography", "Educational Timeline", "Research Timeline",
  "Event Timeline", "Portfolio Timeline", "News Timeline", "Custom",
];

export const themeOf = (id) => THEMES[id] || THEMES.aurora;
export const sortEvents = (events = []) =>
  [...events].sort((a, b) => (Number(a.year) || 0) - (Number(b.year) || 0));
